module.exports = __webpack_public_path__ + "static/media/green-mobility.6bba1f43.jpg";